import React from 'react';
import './css/review.css';

function Reviews(prop: {reviewlst: Object[][]}) {
    const validReviews = (prop.reviewlst || []).filter((review) => Array.isArray(review) && review.length > 0);

    if (validReviews.length === 0) {
        return <p className="no-results">No reviews yet.</p>;
    }

    return(
        <div className="review-list">
            {validReviews.map((review, index) =>
                <div className="review-card" key={index}>
                    <div className="review-card-head">
                        <span className="review-dorm">{review[0]}</span>
                        <div className="star-rating read-only">
                            {[...Array(5)].map((star, i) => {
                                i += 1;
                                return (
                                    <button type="button" key={i} className={i <= review[2] ? "on" : "off"}>
                                        <span>&#9733;</span>
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                    <p className="review-text">{review[1]}</p>
                    {review[3] ? <img className="review-photo" src={review[3]} alt={`Uploaded for ${review[0] || "this dorm"} review`}/> : null}
                </div>
            )}
        </div>
    )
}

export default Reviews;
